// extracted by mini-css-extract-plugin
export default {"cta":"qI-z","disabled":"rI-z"};